import {Parameter, RedactAnnotation} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalRedactAnnotation extends RedactAnnotation implements Parameter {
	public apply?: boolean;

	constructor(data: any) {
		super(data);

		this.apply = FunctionHelper.exists(data.apply) ? data.apply : true;
	}

	public static getApplyDefault(): boolean {
		return true;
	}

	public static fromJson(data: any): PortalRedactAnnotation {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalRedactAnnotation(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'apply': this.apply
		};
	}

	public clone(): PortalRedactAnnotation {
		return PortalRedactAnnotation.fromJson(this.toJson());
	}
}